import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import imageSrc from '../../assets/images/imagePiggy.png'
import { NavLink } from 'react-router-dom';

export default React.memo(function PartnersEpicBlock({
                                                       children
                                                     }) {
  const { t } = useTranslation('common');

  const listData = useMemo(() => {
    const result = [];
    for (let i = 0; i <= 2; i++) {
      result.push(<li key={i}>{t(`descriptions.partners_${i}`)}</li>);
    }
    return result;
  }, [i18n.language]);

  return (
    <div className={'pt-20 overflow-hidden'}>
      <div className={'grid grid-cols-1 md:grid-cols-7 w-full bg-brandedColor-ORANGE'}>
        <div className={'w-full col-span-4 py-20 pl-24 pr-0'}>

          <div className="mb-4 text-[36px] md:text-[56px] font-medium tracking-tight leading-[1.16] text-black">
            <span>{t('titles.partners_epic')}</span></div>
          <p className="text-black pb-4 text-xl font-normal leading-normal">{t('descriptions.partners_main')}</p>
          <ul className="list-disc pl-6 pb-10 text-xl font-normal leading-normal">
            {listData}
          </ul>
          <div className={'flex'}>
            <NavLink to={'/contacts'} className={'block text-white'}>
                  <span
                    className={'block py-[10px] px-[15px] bg-white text-base overflow-hidden rounded-lg '}>
                    <span className={'relative text-black z-[1] select-none'}>
                      {t('buttons.become_partner')}
                    </span>
                  </span>
            </NavLink>
          </div>

        </div>
        <div className={'relative w-full col-span-3 min-h-[300px]'}>
          <img src={imageSrc}
               className={' absolute scale-[1.5] sm:scale-110 md:scale-[2] lg:scale-150 top-1/4 sm:-top-6 -left-8 md:top-1/4 lg:top-16 transform md:translate-y-10 lg:translate-y-16'}
               alt={'game character'} />
        </div>

      </div>
    </div>
  );
})
